// Petit catalogue d'aliments courants, pour l'ajout à la main d'une ligne que le modèle a ratée
// (« le modèle propose, l'utilisateur décide »). Sans lui, un aliment ajouté n'aurait aucune
// composition et ne compterait pour rien dans les totaux — c'est l'option « Autre », qui reste
// possible et s'affiche alors comme « composition inconnue ».
//
// Ordres de grandeur usuels pour 100 g d'aliment PRÊT À MANGER (riz cuit, pâtes cuites…), arrondis :
// ils dépannent, ils ne remplacent pas une fiche Open Food Facts, et l'écran le dit. Le vrai
// générateur de vérité terrain du produit reste POST /api/correction (CLAUDE.md § Contrat d'API).
import type { MacrosPer100g } from '../barcode/types.js';

export interface AlimentCourant {
  cle: string;
  nom: string;
  /** Portion usuelle, en grammes — valeur de départ du curseur. */
  portionG: number;
  macrosPour100g: MacrosPer100g | null;
}

export const ALIMENTS_COURANTS: readonly AlimentCourant[] = [
  m('riz', 'Riz cuit', 150, 130, 28, 2.4, 0.3, 0.4, 0.1, 0.01),
  m('pates', 'Pâtes cuites', 180, 158, 31, 5.8, 0.9, 1.8, 0.6, 0.01),
  m('pommes-de-terre', 'Pommes de terre cuites', 180, 85, 18, 2, 0.2, 2, 0.8, 0.02),
  m('frites', 'Frites', 130, 290, 36, 3.5, 14, 3.5, 0.5, 0.5),
  m('pain', 'Pain', 50, 270, 55, 9, 1.2, 2.7, 2.5, 1.3),
  m('poulet', 'Blanc de poulet', 120, 165, 0, 31, 3.6, 0, 0, 0.2),
  m('boeuf', 'Steak haché 5 %', 120, 170, 0, 26, 7, 0, 0, 0.2),
  m('saumon', 'Saumon cuit', 120, 200, 0, 25, 11, 0, 0, 0.15),
  m('oeuf', 'Œuf', 60, 145, 0.7, 12.6, 10, 0, 0.4, 0.35),
  m('legumes', 'Légumes cuits', 150, 45, 6, 2, 0.6, 3, 3, 0.05),
  m('salade', 'Salade verte', 60, 15, 1.5, 1.2, 0.2, 1.5, 0.8, 0.03),
  m('fromage', 'Fromage à pâte dure', 30, 380, 0.5, 28, 29, 0, 0.5, 0.7),
  m('huile', "Huile d'olive", 10, 900, 0, 0, 100, 0, 0, 0),
  { cle: 'autre', nom: 'Autre (composition inconnue)', portionG: 100, macrosPour100g: null },
];

export function alimentCourant(cle: string): AlimentCourant | undefined {
  return ALIMENTS_COURANTS.find((aliment) => aliment.cle === cle);
}

function m(
  cle: string,
  nom: string,
  portionG: number,
  kcal: number,
  glucides_g: number,
  proteines_g: number,
  lipides_g: number,
  fibres_g: number,
  sucres_g: number,
  sel_g: number,
): AlimentCourant {
  return { cle, nom, portionG, macrosPour100g: { kcal, glucides_g, proteines_g, lipides_g, fibres_g, sucres_g, sel_g } };
}
